import { ITrial, ResponseStatus } from "@/api/dtos";
import { createContext } from "react"

export interface ITrialsContext {
    data?: ITrial[];
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<ITrial[] | undefined>
}

export const TrialsContext = createContext<ITrialsContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<ITrial[] | undefined>(res => {
            res(undefined);
        });
    }
});

export default TrialsContext;